/**
 * Builds a login URL with the org parameter for custom branding.
 * Optionally includes a redirect_to parameter.
 */
export function buildLoginUrl(
  orgId?: number | null,
  redirectTo?: string
): string {
  const params = new URLSearchParams();

  if (orgId) {
    params.set("org", String(orgId));
  }
  if (redirectTo) {
    params.set("redirect_to", redirectTo);
  }

  const queryString = params.toString();
  return `/login${queryString ? `?${queryString}` : ""}`;
}
